module.exports = __webpack_public_path__ + "media/img/icons/accardion-arrow-41264d85dc34653a90e38b351202e2f6.svg";